module.exports = __webpack_public_path__ + "frontStatic/img/wxcode.dd040036.png";